import { getAuth0Instance } from '@/plugins/auth0'
import { resolveOrganizationInvitation } from '@/plugins/auth0/invitation'

// eslint-disable-next-line import/prefer-default-export
export const authGuard = (to, _, next) => {
  // `/login` (invite links included) must not wait on Auth0 loading. Bootstrap
  // owns the redirect; blocking here left invitation query params unread when
  // the old code only looked at route params.
  if (to.name === 'auth-login-redirect' || to.path === '/login') {
    return next()
  }

  const authService = getAuth0Instance()

  const fn = () => {
    if (authService.isAuthenticated) {
      return next()
    }

    const { organization, invitation } = resolveOrganizationInvitation({
      search: typeof window !== 'undefined' ? window.location.search : '',
      query: to.query,
      params: to.params,
    })

    if (organization && invitation) {
      return authService.loginWithRedirect({
        organization,
        invitation,
        appState: { targetUrl: to.fullPath },
      })
    }

    return authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
  }

  if (!authService.loading) {
    return fn()
  }

  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn()
    }
  })
}
